// The objective tell of an arcade structure (arcade.md §7.2, §19.2, R2029):
// a pennant on a staff at the upper right of the cell. The map designer
// draws it in the owner ink on its plain 2D map, and the atlas bakes it
// WHITE as the site cell `site:flag`, which the site layer of a match tints
// with the owner ink. One path serves both, so the two pictures cannot
// drift. The figures are `[presentation.arcade.capture]`.

import { ARCADE_CAPTURE } from '../gen/presentation';
import { HEX_SIZE } from '../world';

/** The atlas key of the white objective tell (`fast/gfx/atlas.ts`). */
export const OBJECTIVE_FLAG_KEY = 'site:flag';

/**
 * Traces and inks the tell of a structure whose centre is `cx, cy`: the
 * staff from the rim of the mark up past the top of the cell, and the
 * pennant to its right. The fill takes `flagFillAlpha`; the outline takes
 * the full ink. Both multiply the alpha the caller set.
 */
export function paintObjectiveFlag(g: CanvasRenderingContext2D, cx: number, cy: number, ink: string): void {
  const F = ARCADE_CAPTURE;
  const x = cx + HEX_SIZE * F.flagDxHex;
  const top = cy + HEX_SIZE * F.flagTopDyHex;
  g.save();
  g.beginPath();
  g.moveTo(x, cy + HEX_SIZE * F.flagFootDyHex);
  g.lineTo(x, top);
  g.lineTo(x + HEX_SIZE * F.flagLenHex, top + HEX_SIZE * F.flagTipDyHex);
  g.lineTo(x, top + HEX_SIZE * F.flagDropHex);
  // The fill and the outline keep the alpha of the caller, so a fade of the
  // caller fades the tell too.
  const a = g.globalAlpha;
  g.fillStyle = ink;
  g.globalAlpha = a * F.flagFillAlpha;
  g.fill();
  g.globalAlpha = a;
  g.lineWidth = F.flagLinePx;
  g.strokeStyle = ink;
  g.stroke();
  g.restore();
}
